<template>
  <div>
      <el-button  type="success"
           icon="el-icon-download"  @click="onButtonTitleButton">{{buttonTitle}}</el-button>
  </div>
</template>

<script>
import {emailStatus,formatDate} from '@/filters'
import { export_json_to_excel } from "@/excel/Export2Excel";
export default {
   props: {
    buttonTitle:{
        type: String,
        default: ''
    },
    path:{
        type: String,
        default: ''
    },
    moduleTitle:{
        type: String,
        default: 'email Log'
    },
    tableLabels: {
      type: Array,
      default: function(){},
    },
    labels: {
      type: Array,
      default: function(){},
    },
  },
  methods: {
    onButtonTitleButton(){
        this.exportExcel()
    },
    exportExcel() {
      require.ensure([], () => {
        const tHeader = this.tableLabels.map((v) => {
          return v.label;
        }); // Excel的表头
        const filterVal = this.tableLabels.map((v) => {
          return v.prop;
        }); // 数据对应的字段
        let list=''
        if(this.moduleTitle == 'email Log'){
           list = this.labels.map((v)=>{ 
            v.sendAt =  formatDate(v.sendAt)
            v.status =  emailStatus(v.status)
             return v
           })
        }
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, this.moduleTitle);
      });
    },
    formatJson(filterVal, jsonData) {
      if(jsonData.length>0){
       return jsonData.map((v) => filterVal.map((j) => v[j]));
      } else {
        return []
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
</style>